export default "__VITE_ASSET__UHA52bL2__"